let SQLp;

export function loadSQL() {
  if (!SQLp) {
    SQLp = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "/sqljs/sql-wasm.js";
      s.onload = () => window.initSqlJs({ locateFile: (f) => `/sqljs/${f}` }).then(resolve, reject);
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return SQLp;
}

export const SCHEMA = `
PRAGMA secure_delete=ON;
CREATE TABLE IF NOT EXISTS profile(id TEXT PRIMARY KEY, alias TEXT, sign_pk TEXT, sign_sk TEXT, box_pk TEXT, box_sk TEXT, code TEXT, decoy_pin_active INTEGER, theme_state TEXT, created_at INTEGER);
CREATE TABLE IF NOT EXISTS contacts(code TEXT PRIMARY KEY, alias TEXT, nickname TEXT, sign_pk TEXT, box_pk TEXT, routing_id TEXT, shared_secret TEXT, lock_status TEXT, created_at INTEGER);
CREATE TABLE IF NOT EXISTS sessions(session_id TEXT PRIMARY KEY, kind TEXT, name TEXT, recipient_code TEXT, members TEXT, self_destruct_timer INTEGER, last_at INTEGER, unread INTEGER DEFAULT 0, created_at INTEGER);
CREATE TABLE IF NOT EXISTS messages(message_id TEXT PRIMARY KEY, session_id TEXT, sender_code TEXT, timestamp INTEGER, content TEXT, burn_on_read INTEGER, timer INTEGER, burn_at INTEGER, read_at INTEGER, status TEXT, delivered_to TEXT DEFAULT '[]', read_by TEXT DEFAULT '[]');
CREATE TABLE IF NOT EXISTS stories(story_id TEXT PRIMARY KEY, author_code TEXT, timestamp INTEGER, expires_at INTEGER, content TEXT, seen INTEGER DEFAULT 0, viewed_by TEXT DEFAULT '[]');
CREATE INDEX IF NOT EXISTS idx_msg_session ON messages(session_id, timestamp);
`;

export function all(db, sql, params = []) {
  const st = db.prepare(sql);
  st.bind(params);
  const rows = [];
  while (st.step()) rows.push(st.getAsObject());
  st.free();
  return rows;
}

export const one = (db, sql, params) => all(db, sql, params)[0];
